module.exports = __webpack_public_path__ + "web/img/articles3.e6e968a7.png";